import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import {UserService} from "../services/core/user.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private currentUser: UserService) {
  }

  /** Public auth endpoints that must never carry an Authorization header. */
  private static readonly PUBLIC_PATHS = [
    '/login',
    '/auth/impersonate',
    '/forgot-password',
    '/reset-password',
  ];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isPublicEndpoint = AuthInterceptor.PUBLIC_PATHS.some(path => req.url.includes(path));

    if (isPublicEndpoint) {
      return next.handle(req);
    }

    req = req.clone({
      setHeaders: {
        'Authorization': `Bearer ${this.currentUser.getToken()}`,
      },
    });
    return next.handle(req);
  }
}
